"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EcolineBot = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const Size_1 = require("../render/Size");
const AresHandler_1 = require("../../ares/AresHandler");
const AutomaHandler_1 = require("../../automa/AutomaHandler");
const constants_1 = require("../../constants");
const GameSetup_1 = require("../../GameSetup");
const SpaceType_1 = require("../../SpaceType");
const TileType_1 = require("../../TileType");
class EcolineBot extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.ECOLINE_BOT,
            startingMegaCredits: 0,
            metadata: {
                cardNumber: 'AU01',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.corpBox('action', (ce) => {
                        ce.vSpace(Size_1.Size.LARGE);
                        ce.action('Place a greenery.', (eb) => {
                            eb.empty().startAction.greenery();
                        });
                        ce.vSpace();
                        ce.effect('If this bot places a Greenery that is not adjacent to their own City, their next action is to place a City regardless of the tag.', (eb) => {
                            eb.wild(1).played.startEffect.city().asterix();
                        });
                        ce.vSpace();
                    });
                }),
            },
        });
    }
    play() {
        return undefined;
    }
    initialAction() {
        return undefined;
    }
    canAct() {
        return true;
    }
    action(player) {
        const game = player.game;
        const neutral = GameSetup_1.GameSetup.neutralPlayerFor(game.id);
        this.placeGreenery(game, neutral);
        return undefined;
    }
    placeGreenery(game, neutral) {
        const landSpacesCount = game.board.getAvailableSpacesOnLand(neutral).length;
        if (landSpacesCount === 0) {
            game.automaBotVictoryPointsBreakdown.terraformRating++;
            game.log('${0} action: Gain 1 TR as there are no greenery spots left', (b) => b.card(this));
            return undefined;
        }
        AutomaHandler_1.AutomaHandler.increaseOxygenLevel(game, 1);
        game.automaBotVictoryPointsBreakdown.terraformRating++;
        game.automaBotVictoryPointsBreakdown.greenery++;
        if (game.getOxygenLevel() === 8 && game.getTemperature() !== constants_1.MAX_TEMPERATURE) {
            this.raiseTemperature(game, neutral);
        }
        const targetGreenerySpace = AutomaHandler_1.AutomaHandler.getTargetGreenerySpace(game, neutral);
        game.simpleAddTile(neutral, game.board.getSpace(targetGreenerySpace.id), { tileType: TileType_1.TileType.GREENERY });
        AutomaHandler_1.AutomaHandler.grantBonusesForBotTilePlacement(game, targetGreenerySpace, neutral, TileType_1.TileType.GREENERY);
        game.oxygenSilverCubeBonusMC = 0;
        game.log('${0} action: Place a greenery on row ${1} position ${2}', (b) => b.card(this).number(targetGreenerySpace.y + 1).number(targetGreenerySpace.x - Math.abs(targetGreenerySpace.y - 4) + 1));
        const adjacentCities = game.board.getAdjacentSpaces(targetGreenerySpace).filter((space) => { var _a, _b; return space.spaceType === SpaceType_1.SpaceType.LAND && ((_a = space.tile) === null || _a === void 0 ? void 0 : _a.tileType) === TileType_1.TileType.CITY && ((_b = space.player) === null || _b === void 0 ? void 0 : _b.name) === neutral.name; });
        game.automaBotVictoryPointsBreakdown.city += adjacentCities.length;
        if (adjacentCities.length === 0) {
            game.overwriteNextBotAction = true;
        }
    }
    raiseTemperature(game, neutral) {
        AutomaHandler_1.AutomaHandler.increaseTemperature(game, 1);
        game.automaBotVictoryPointsBreakdown.terraformRating++;
        game.temperatureSilverCubeBonusMC = 0;
        AutomaHandler_1.AutomaHandler.checkForTemperatureBonusOcean(game, neutral);
        AresHandler_1.AresHandler.ifAres(game, (aresData) => {
            AresHandler_1.AresHandler.onTemperatureChange(game, aresData);
        });
    }
}
exports.EcolineBot = EcolineBot;
//# sourceMappingURL=EcolineBot.js.map